module.exports = __webpack_public_path__ + "img/trip_01.6b853762.jpg";